export type StronomModuleStatus = "foundation" | "active" | "coming_soon";

export interface StronomModule {
  key: "core" | "design" | "build" | "motion" | "compliance" | "media" | "gov" | "agents";
  title: string;
  icon: string;
  description: string;
  status: StronomModuleStatus;
  statusLabel: string;
  slug: string;
  accentVar: string;
  ctaLabel?: string;
  ctaLink?: string;
}

export const stronomModules: StronomModule[] = [
  {
    key: "core",
    title: "STRONOM Core",
    icon: "/stronom-icons/core.svg",
    description:
      "The foundation of all modules. Defines structure, validates logic, and governs every connected system.",
    status: "foundation",
    statusLabel: "Framework Foundation",
    slug: "/core",
    accentVar: "--color-core",
  },
  {
    key: "design",
    title: "STRONOM Design",
    icon: "/stronom-icons/design.svg",
    description:
      "Enables creative industries to turn intent into structured, validated design outcomes. Currently functional for the Footwear Studio.",
    status: "active",
    statusLabel: "Active — Open Studio",
    slug: "/design",
    accentVar: "--color-design",
    ctaLabel: "Open Studio",
    ctaLink: "/design",
  },
  {
    key: "build",
    title: "STRONOM Build",
    icon: "/stronom-icons/build.svg",
    description:
      "Focused on architecture and engineering — transforming digital projects into compliant, safe, and auditable results.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/build",
    accentVar: "--color-build",
  },
  {
    key: "motion",
    title: "STRONOM Motion",
    icon: "/stronom-icons/motion.svg",
    description:
      "For robotics, drones, and autonomous systems. Ensures every movement follows safety and rule-based logic.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/motion",
    accentVar: "--color-motion",
  },
  {
    key: "compliance",
    title: "STRONOM Compliance",
    icon: "/stronom-icons/compliance.svg",
    description:
      "Built for healthcare, finance, and legal sectors to ensure every automated process meets ethical and regulatory standards.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/compliance",
    accentVar: "--color-compliance",
  },
  {
    key: "media",
    title: "STRONOM Media",
    icon: "/stronom-icons/media.svg",
    description:
      "Empowers creative and marketing teams to maintain brand safety, content integrity, and copyright compliance.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/media",
    accentVar: "--color-media",
  },
  {
    key: "gov",
    title: "STRONOM Gov",
    icon: "/stronom-icons/gov.svg",
    description:
      "Supports governments and institutions in building transparent, traceable digital services with built-in accountability.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/gov",
    accentVar: "--color-gov",
  },
  {
    key: "agents",
    title: "STRONOM Agents",
    icon: "/stronom-icons/agents.svg",
    description:
      "Governs enterprise AI assistants and automation tools, ensuring compliant, consistent, and secure behavior.",
    status: "coming_soon",
    statusLabel: "Coming Soon",
    slug: "/agents",
    accentVar: "--color-agents",
  },
];
